'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildFilteredChangeMetadata = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _buildFilteredChangeInfo = require('./buildFilteredChangeInfo');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _FilteredChangeMetadata = require('../records/FilteredChangeMetadata');

var _FilteredChangeMetadata2 = _interopRequireDefault(_FilteredChangeMetadata);

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildFilteredChangeMetadata = exports.buildFilteredChangeMetadata = function buildFilteredChangeMetadata(attrs) {
  var jsAttrs = attrs;
  if (_immutable.Iterable.isIterable(attrs)) {
    jsAttrs = attrs.toJS();
  }
  var passedFilteredChangeInfo = (0, _get2.default)('filteredChangeInfo', jsAttrs);

  var filteredChangeInfo = (0, _buildFilteredChangeInfo.buildFilteredChangeInfo)(passedFilteredChangeInfo);

  return (0, _FilteredChangeMetadata2.default)(_extends({}, jsAttrs, {
    filteredChangeInfo: filteredChangeInfo
  }));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/filtered-change-message-metadata/operators/buildFilteredChangeMetadata.js
// module id = 722
// module chunks = 2 3